import Headline from "./atoms/headline"

const STEPS = [
    {
        number: '1',
        topic: '電話かメールで連絡',
        sentence: <>お電話またはメールで<br />ご連絡ください</>,
    },
    {
        number: '2',
        topic: 'スタジオの説明',
        sentence: <>ご利用当日にお早めに来ていただくか、<br />事前にスタジオに来ていただきます。<br />説明は15分ほどです</>,
    },
    {
        number: '3',
        topic: 'ご利用',
        sentence: 'お支払いは現金又は口座振込のみです。',
    },
]

const ExternalLinkIcon = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M14 4h6v6" />
        <path d="M20 4l-9 9" />
        <path d="M19 14v6H4V5h6" />
    </svg>
)

const Service = () => {
    return (
        <div id='service' className='section'>
            <Headline
                title={'Service'}
                subTitle={'サービス'}
            />
            <div className="step-list">
                {STEPS.map((step) => (
                    <div className="step" key={step.number}>
                        <p className="number">{step.number}</p>
                        <p className="topic">{step.topic}</p>
                        <p className="sentence">{step.sentence}</p>
                    </div>
                ))}
            </div>
            <div className="document-links">
                <a
                    href={process.env.PUBLIC_URL + '/docs/term.pdf'}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    利用規約
                    <ExternalLinkIcon />
                </a>
                <a
                    href={process.env.PUBLIC_URL + '/docs/privacy.pdf'}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    個人情報保護方針
                    <ExternalLinkIcon />
                </a>
            </div>
        </div>
    )
}

export default Service
